import { useAppDispatch, useAppSelector } from 'redux-store';
import { closeModal, openModal } from 'redux-store/slices/ui';

import type { UseModalHook } from './types';

export const useModal: UseModalHook = modalConfig => {
  const dispatch = useAppDispatch();
  const { isOpenModal, modalType, redirectUrl } = useAppSelector(appState => {
    return {
      isOpenModal: appState.ui.isOpenModal,
      modalType: appState.ui.modalType,
      redirectUrl: appState.ui.redirectUrl,
    };
  });
  const { type, onClose, onShow, ...restProps } = modalConfig;

  const show = (): void => {
    dispatch(openModal({ type }));

    if (onShow) {
      onShow();
    }
  };

  const close = (): void => {
    dispatch(closeModal());

    if (onClose) {
      onClose();
    }
  };

  const modalProps = {
    ...restProps,
    isOpen: isOpenModal && modalType === type,
    redirectUrl,
    onRequestClose: close,
  };

  return {
    isVisible: isOpenModal && modalType === type,
    show,
    close,
    modalProps,
  };
};
